import { Outlet } from 'react-router';

import Header from './headers/Header';

export default function MainLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <Header />

      <main className="flex-1 overflow-y-auto" id="main">
        <Outlet />
      </main>
    </div>
  );
}
